'use client'

import { FC, ReactElement } from 'react'

// Vercel Web Analytics + Speed Insights are intentionally NOT rendered.
//
// Both products were dropped to cut Vercel cost:
//   - Speed Insights (~$20-30/mo) removed in the prior cost-cut PR.
//   - Web Analytics (~$13/mo combined: Plus subscription + per-event) removed
//     in this one. They weren't actively reviewed so the cost wasn't
//     justified.
//
// To re-enable later:
//   - Web Analytics: `pnpm add @vercel/analytics` then render
//     `<Analytics />` from `@vercel/analytics/react` here. Use `beforeSend`
//     to sample pageview events down (we previously ran at 25% via
//     `NEXT_PUBLIC_ANALYTICS_PAGEVIEW_SAMPLE_RATE`).
//   - Speed Insights: `pnpm add @vercel/speed-insights` then render
//     `<SpeedInsights sampleRate={0.1} />` from `@vercel/speed-insights/next`.
//
// If you need traffic analytics in the meantime, consider a self-hosted
// option (Plausible / PostHog OSS) on a $5/mo VPS — same data, lower bill.
const Analytics: FC = (_props): ReactElement | null => {
	return null
}

export default Analytics
